/* =========================================================================
   Zero Hour M/C — storefront interactions
   Self-contained. No dependencies. Safe to remove by deleting this file
   and its <script> tag in layout/theme.liquid.

   CONFIG is at the top. Everything below is feature modules; each one
   is independently guarded so a missing element can never break the page.
   ========================================================================= */
(function () {
  'use strict';

  /* ------------------------------ CONFIG ------------------------------ */
  var CFG = {
    // Free-shipping meter in the cart drawer.
    // null = feature OFF. Set to a number in CENTS to turn it on (e.g. 9900 = $99).
    // Do NOT enable this unless a matching free-shipping rate actually exists
    // in Settings > Shipping, or the storefront will promise something real
    // checkout won't honor.
    freeShipThresholdCents: null,

    stickyAtcMaxWidth: 989,   // sticky add-to-cart shows at/below this px width
    recentlyViewedMax: 8,
    backToTopAfterPx: 800,
    eggsEnabled: true
  };

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LS = 'zh:';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function guard(name, fn) { try { fn(); } catch (e) { console.warn('[zh] ' + name + ' skipped:', e); } }
  function store(k, v) {
    try {
      if (v === undefined) { var r = localStorage.getItem(LS + k); return r ? JSON.parse(r) : null; }
      localStorage.setItem(LS + k, JSON.stringify(v));
    } catch (e) { return null; }
  }

  /* ---------------------------- TITLE HELPER ---------------------------- */
  /* Dawn renders the product title twice inside .product__title — an <h1>
     plus a linked <h2> duplicate. A comma-separated querySelector returns
     whichever node comes first in DOCUMENT order, not whichever selector is
     listed first, so '.product__title h1, .product__title' hands back the
     wrapping div and its text contains the name twice. Ask for the h1 on its
     own first, and collapse whitespace either way. */
  function productTitleText() {
    var el = $('.product__title h1') || $('h1.product__title') || $('.product__title');
    if (!el) return '';
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  /* --------------------------- SCROLL HELPER ---------------------------- */
  /* The theme stylesheet sets `html { scroll-behavior: smooth }`. On this
     store that makes window.scrollTo({ behavior: 'smooth' }) a no-op —
     verified in the browser: the call returns cleanly but scrollTop never
     changes, and a direct `documentElement.scrollTop = 0` is ignored too.
     Forcing scroll-behavior to 'auto' and animating scrollTop ourselves
     works regardless of what the stylesheet declares. */
  function scrollToTop() {
    var de = document.documentElement;
    var start = de.scrollTop;
    if (start <= 0) return;

    var prev = de.style.scrollBehavior;
    de.style.scrollBehavior = 'auto';

    if (REDUCED) {
      de.scrollTop = 0;
      de.style.scrollBehavior = prev;
      return;
    }

    var dur = Math.min(650, Math.max(300, start * 0.4));
    var t0 = null;
    function step(now) {
      if (t0 === null) t0 = now;
      var t = Math.min(1, (now - t0) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      de.scrollTop = start * (1 - eased);
      if (t < 1) {
        requestAnimationFrame(step);
      } else {
        de.scrollTop = 0;
        de.style.scrollBehavior = prev;
      }
    }
    requestAnimationFrame(step);
  }

  /* ---------------------------- TOAST HELPER ---------------------------- */
  var toastTimer;
  function toast(msg, ms) {
    var el = $('#zh-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'zh-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, ms || 2600);
  }

  /* ================================ UX ================================= */

  /* 1. Sticky add-to-cart bar (mobile product pages).
        Mirrors the real button rather than re-implementing it, so Dawn's
        variant logic and cart-drawer behavior stay untouched. */
  function stickyAtc() {
    if (document.body.dataset.zhTemplate !== 'product') return;
    var realBtn = $('product-form [name="add"], .product-form__submit');
    var form = $('product-form form');
    if (!realBtn || !form) return;

    var title = productTitleText();
    var priceEl = $('.price__container .price-item--sale, .price__container .price-item--regular, .price-item');
    var img = $('.product__media img, .product__modal-opener img');

    var bar = document.createElement('div');
    bar.className = 'zh-sticky-atc';
    bar.innerHTML =
      '<div class="zh-sticky-atc__info">' +
        (img ? '<img class="zh-sticky-atc__img" src="' + img.currentSrc + '" alt="" width="40" height="40">' : '') +
        '<div class="zh-sticky-atc__text">' +
          '<span class="zh-sticky-atc__title"></span>' +
          '<span class="zh-sticky-atc__price"></span>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="zh-sticky-atc__btn button button--primary"></button>';

    bar.querySelector('.zh-sticky-atc__title').textContent = title;
    if (priceEl) bar.querySelector('.zh-sticky-atc__price').textContent = priceEl.textContent.trim();

    var btn = bar.querySelector('.zh-sticky-atc__btn');
    function syncBtn() {
      var label = realBtn.querySelector('span');
      btn.textContent = (label ? label.textContent : realBtn.textContent).trim() || 'Add to cart';
      btn.disabled = realBtn.disabled;
      var p = $('.price__container .price-item--sale, .price__container .price-item--regular, .price-item');
      if (p) bar.querySelector('.zh-sticky-atc__price').textContent = p.textContent.trim();
    }
    syncBtn();
    new MutationObserver(syncBtn).observe(realBtn, {
      attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'class']
    });

    on(btn, 'click', function () { realBtn.click(); });
    document.body.appendChild(bar);

    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      bar.classList.toggle('is-visible', !visible && window.innerWidth <= CFG.stickyAtcMaxWidth);
    }, { threshold: 0 });
    io.observe(realBtn);

    on(window, 'resize', function () {
      if (window.innerWidth > CFG.stickyAtcMaxWidth) bar.classList.remove('is-visible');
    });
  }

  /* 2. Click-to-copy part numbers.
        On a Harley parts catalog people cross-reference SKUs against Drag /
        Turn 14 / RWD listings constantly. Making the number one-tap
        copyable is the single highest-value micro-interaction on the site.
        NOTE: this binds to whatever SKU markup the theme renders. If the
        products carry no SKU values in the admin there is nothing on the
        page to bind to and the feature is silently inert — that is a
        catalog-data gap, not a bug here. */
  function copyableSkus() {
    var nodes = $$('.product__sku, [class*="product__sku"], .product-sku, [data-sku]');
    if (!nodes.length) return;

    nodes.forEach(function (node) {
      if (node.dataset.zhCopyBound) return;
      var raw = (node.dataset.sku || node.textContent || '').replace(/^\s*SKU[:\s]*/i, '').trim();
      if (!raw || /^(n\/a|none|-{1,})$/i.test(raw)) return;

      node.dataset.zhCopyBound = '1';
      node.classList.add('zh-copyable');
      node.setAttribute('role', 'button');
      node.setAttribute('tabindex', '0');
      node.setAttribute('title', 'Click to copy part number');

      function doCopy() {
        var done = function () {
          node.classList.add('zh-copied');
          toast('Part number copied — ' + raw);
          setTimeout(function () { node.classList.remove('zh-copied'); }, 1400);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(raw).then(done).catch(function () {});
        } else {
          var ta = document.createElement('textarea');
          ta.value = raw; ta.style.position = 'fixed'; ta.style.opacity = '0';
          document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(ta);
        }
      }
      on(node, 'click', doCopy);
      on(node, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); doCopy(); }
      });
    });
  }

  /* 3. Recently viewed rail — localStorage only, no app, no server calls. */
  function recentlyViewed() {
    var isProduct = document.body.dataset.zhTemplate === 'product';
    var list = store('recent') || [];

    if (isProduct) {
      var title = productTitleText();
      var imgEl = $('.product__media img');
      var priceEl2 = $('.price__container .price-item--sale, .price__container .price-item--regular, .price-item');
      if (title) {
        var entry = {
          url: location.pathname.split('?')[0],
          title: title,
          img: imgEl ? imgEl.currentSrc : '',
          price: priceEl2 ? priceEl2.textContent.trim() : ''
        };
        list = list.filter(function (i) { return i.url !== entry.url; });
        list.unshift(entry);
        list = list.slice(0, CFG.recentlyViewedMax);
        store('recent', list);
      }
    }

    var rest = list.filter(function (i) { return i.url !== location.pathname.split('?')[0]; });
    if (rest.length < 2) return;

    var main = $('#MainContent');
    if (!main) return;

    var wrap = document.createElement('section');
    wrap.className = 'zh-recent page-width';
    wrap.innerHTML =
      '<div class="zh-recent__head">' +
        '<h2 class="zh-recent__title">Back in the stand</h2>' +
        '<button type="button" class="zh-recent__clear">Clear</button>' +
      '</div>' +
      '<div class="zh-recent__rail"></div>';

    var rail = wrap.querySelector('.zh-recent__rail');
    rest.forEach(function (i) {
      var a = document.createElement('a');
      a.className = 'zh-recent__card';
      a.href = i.url;
      a.innerHTML =
        (i.img ? '<img class="zh-recent__img" src="' + i.img + '" alt="" loading="lazy">' : '<span class="zh-recent__img zh-recent__img--empty"></span>') +
        '<span class="zh-recent__name"></span>' +
        '<span class="zh-recent__price"></span>';
      a.querySelector('.zh-recent__name').textContent = i.title;
      a.querySelector('.zh-recent__price').textContent = i.price;
      rail.appendChild(a);
    });

    on(wrap.querySelector('.zh-recent__clear'), 'click', function () {
      store('recent', []);
      wrap.remove();
      toast('Recently viewed cleared');
    });

    main.appendChild(wrap);
  }

  /* 4. Keyboard: "/" focuses search, Esc clears it. */
  function searchHotkey() {
    on(document, 'keydown', function (e) {
      var t = e.target;
      var typing = t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable);
      if (e.key === '/' && !typing && !e.metaKey && !e.ctrlKey) {
        var input = $('predictive-search input[type="search"], .search__input, input[name="q"]');
        var opener = $('details-modal .header__icon--search, .header__icon--search');
        if (!input && opener) { opener.click(); }
        setTimeout(function () {
          var i = $('predictive-search input[type="search"], .search__input, input[name="q"]');
          if (i) { e.preventDefault(); i.focus(); i.select(); }
        }, 60);
      }
      if (e.key === 'Escape' && typing && t.type === 'search') { t.blur(); }
    });
  }

  /* 5. Back to top. */
  function backToTop() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'zh-totop';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12 5l7 7-1.4 1.4L13 8.8V19h-2V8.8l-4.6 4.6L5 12z" fill="currentColor"/></svg>';
    on(btn, 'click', scrollToTop);
    document.body.appendChild(btn);
    var tick;
    on(window, 'scroll', function () {
      if (tick) return;
      tick = requestAnimationFrame(function () {
        btn.classList.toggle('is-visible', window.scrollY > CFG.backToTopAfterPx);
        tick = null;
      });
    }, { passive: true });
  }

  /* 6. Free-shipping meter in the cart drawer. OFF unless configured. */
  function freeShipMeter() {
    if (!CFG.freeShipThresholdCents) return;
    var drawer = $('cart-drawer');
    if (!drawer) return;

    function render() {
      fetch(window.routes ? window.routes.cart_url + '.js' : '/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var target = CFG.freeShipThresholdCents;
          var pct = Math.min(100, Math.round((cart.total_price / target) * 100));
          var remain = Math.max(0, target - cart.total_price);
          var bar = $('.zh-ship', drawer);
          if (!bar) {
            bar = document.createElement('div');
            bar.className = 'zh-ship';
            var anchor = $('.drawer__inner', drawer) || drawer;
            anchor.insertBefore(bar, anchor.firstChild);
          }
          bar.innerHTML =
            '<p class="zh-ship__label"></p>' +
            '<div class="zh-ship__track"><span class="zh-ship__fill" style="width:' + pct + '%"></span></div>';
          bar.querySelector('.zh-ship__label').textContent = remain === 0
            ? 'Free shipping unlocked.'
            : '$' + (remain / 100).toFixed(2) + ' from free shipping';
        })
        .catch(function () {});
    }
    render();
    document.addEventListener('cart:refresh', render);
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, render); } catch (e) {}
    }
  }

  /* ============================= EASTER EGGS ============================= */

  /* A. Zero Hour. Between 00:00 and 00:59 the store acknowledges its own name:
        a headlight sweep across the top of the page and a small marker. */
  function zeroHour() {
    var h = new Date().getHours();
    if (h !== 0) return;
    document.body.classList.add('zh-egg-zerohour');
    var m = document.createElement('div');
    m.className = 'zh-zerohour-mark';
    m.innerHTML = '<span class="zh-zerohour-dot"></span> It is zero hour.';
    document.body.appendChild(m);
    setTimeout(function () { m.classList.add('is-visible'); }, 900);
    setTimeout(function () { m.classList.remove('is-visible'); }, 9000);
  }

  /* B. Konami code -> Ghost Rider mode (10s). */
  function konami() {
    var seq = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'];
    var pos = 0;
    on(document, 'keydown', function (e) {
      var k = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      pos = (k === seq[pos]) ? pos + 1 : (k === seq[0] ? 1 : 0);
      if (pos === seq.length) {
        pos = 0;
        document.body.classList.add('zh-egg-ghost');
        toast('GHOST RIDER MODE', 4000);
        setTimeout(function () { document.body.classList.remove('zh-egg-ghost'); }, 10000);
      }
    });
  }

  /* C. Type "kickstart" anywhere -> engine crank: tach needle sweep + shake. */
  function kickstart() {
    var word = 'kickstart', buf = '';
    on(document, 'keydown', function (e) {
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
      if (e.key.length !== 1) return;
      buf = (buf + e.key.toLowerCase()).slice(-word.length);
      if (buf !== word) return;
      buf = '';

      var tach = document.createElement('div');
      tach.className = 'zh-tach';
      tach.innerHTML =
        '<svg viewBox="0 0 120 120" width="120" height="120" aria-hidden="true">' +
          '<circle cx="60" cy="60" r="54" class="zh-tach__face"/>' +
          '<path d="M60 60 L60 14" class="zh-tach__needle"/>' +
          '<text x="60" y="86" text-anchor="middle" class="zh-tach__label">RPM</text>' +
        '</svg>';
      document.body.appendChild(tach);
      if (!REDUCED) document.body.classList.add('zh-egg-crank');
      requestAnimationFrame(function () { tach.classList.add('is-running'); });
      setTimeout(function () {
        document.body.classList.remove('zh-egg-crank');
        tach.classList.remove('is-running');
        setTimeout(function () { tach.remove(); }, 500);
      }, 2400);
    });
  }

  /* D. Seven taps on the logo -> shop notes panel. */
  function logoTaps() {
    var logo = $('.header__heading-logo-wrapper, .header__heading-link, .header__heading a');
    if (!logo) return;
    var notes = [
      'Torque specs are not suggestions.',
      'If it leaks, it still has oil in it.',
      'Blue Loctite. Always blue.',
      'Measure the bolt. Then measure it again.',
      'The part you need is always one size up.',
      'Zip ties are a temporary solution for about four years.',
      'Never trust a chrome bolt on a hot header.'
    ];
    var count = 0, timer;
    on(logo, 'click', function (e) {
      count++;
      clearTimeout(timer);
      timer = setTimeout(function () { count = 0; }, 1200);
      if (count < 7) return;
      e.preventDefault();
      count = 0;
      var panel = $('.zh-notes');
      if (panel) { panel.remove(); return; }
      panel = document.createElement('aside');
      panel.className = 'zh-notes';
      panel.innerHTML =
        '<button type="button" class="zh-notes__close" aria-label="Close">&times;</button>' +
        '<p class="zh-notes__kicker">Shop notes</p>' +
        '<p class="zh-notes__body"></p>';
      panel.querySelector('.zh-notes__body').textContent = notes[Math.floor(Math.random() * notes.length)];
      on(panel.querySelector('.zh-notes__close'), 'click', function () { panel.remove(); });
      document.body.appendChild(panel);
      requestAnimationFrame(function () { panel.classList.add('is-visible'); });
    });
  }

  /* E. Console note for anyone poking at the source. */
  function consoleEgg() {
    try {
      console.log('%c ZERO HOUR M/C ', 'background:#111;color:#e8e8e8;font-weight:700;padding:4px 10px;letter-spacing:3px;');
      console.log('%cLooking under the hood? Try the Konami code. Or type "kickstart".', 'color:#888');
    } catch (e) {}
  }

  /* =============================== BOOT ================================ */
  function init() {
    document.body.dataset.zhTemplate = (($('main[data-template]') || {}).dataset || {}).template || '';

    guard('stickyAtc', stickyAtc);
    guard('copyableSkus', copyableSkus);
    guard('recentlyViewed', recentlyViewed);
    guard('searchHotkey', searchHotkey);
    guard('backToTop', backToTop);
    guard('freeShipMeter', freeShipMeter);

    if (CFG.eggsEnabled) {
      guard('zeroHour', zeroHour);
      guard('konami', konami);
      guard('kickstart', kickstart);
      guard('logoTaps', logoTaps);
      guard('consoleEgg', consoleEgg);
    }

    // Re-bind SKU copy after variant swaps re-render the block.
    new MutationObserver(function () { guard('copyableSkus', copyableSkus); })
      .observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
